export class EbTtCategorieDeviation {
	ebTtCategorieDeviationNum: number;
	code: number;
	libelle: string;

	constructor() {
		this.ebTtCategorieDeviationNum = null;
		this.code = null;
		this.libelle = null;
	}
}


// WEBPACK FOOTER //
// ./src/app/classes/categorieDeviation.ts